module.exports = __webpack_public_path__ + "img/style-transfer.61fbeb15.png";